"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAiHubSettingsConfig = void 0;
var react_1 = require("react");
var ai_hub_settings_api_service_1 = __importDefault(require("../../shared/services/ai-hub-settings-api.service"));
var ai_hub_settings_utils_1 = require("../utils/ai-hub-settings-utils");
var ai_hub_settings_change_flags_1 = require("../utils/ai-hub-settings-change-flags");
var ai_hub_settings_reducer_1 = require("../utils/ai-hub-settings-reducer");
/**
 * Validate that an API response has the structural shape we expect before
 * letting it cross into the editor. Catches malformed proxy responses,
 * cache-poisoning, and accidental backend regressions before they propagate
 * into the reducer.
 */
var isWsAiHubSettingsSchemaShape = function (value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    var candidate = value;
    return (Array.isArray(candidate.systems) &&
        Array.isArray(candidate.workflows) &&
        Array.isArray(candidate.fields));
};
/**
 * Strip any `__clientId` markers that may have been sent by the server (or
 * by a hostile proxy). Internal id generation must own the namespace so a
 * malicious payload cannot collide with editor-generated ids and disrupt
 * selection state.
 */
var stripServerClientIds = function (schema) { return ({
    systems: schema.systems.map(function (system) {
        var _systemClientId = system.__clientId, rest = __rest(system, ["__clientId"]);
        return rest;
    }),
    workflows: (schema.workflows || []).map(function (workflow) {
        var _workflowClientId = workflow.__clientId, rest = __rest(workflow, ["__clientId"]);
        return rest;
    }),
    fields: schema.fields.map(function (field) {
        var _fieldClientId = field.__clientId, mapping = field.mapping, restField = __rest(field, ["__clientId", "mapping"]);
        return __assign(__assign({}, restField), { mapping: (mapping || []).map(function (entry) {
                var _mappingClientId = entry.__clientId, restMapping = __rest(entry, ["__clientId"]);
                return restMapping;
            }) });
    }),
}); };
/**
 * Empty schema returned for first-time installs (404 from the GET endpoint).
 * Frozen so a stray reducer or component cannot mutate the singleton and
 * pollute the next render. (The reducer always deep-clones via
 * `cloneAiHubSettingsSchema` before mutating, so the inner arrays are never
 * touched in practice — the freeze is defense in depth.)
 */
var EMPTY_SETTINGS_SCHEMA = Object.freeze({
    systems: [],
    workflows: [],
    fields: [],
});
exports.useAiHubSettingsConfig = function (service) {
    if (service === void 0) { service = ai_hub_settings_api_service_1.default; }
    var _a = react_1.useReducer(ai_hub_settings_reducer_1.settingsReducer, null, function () {
        return ai_hub_settings_reducer_1.createInitialSettingsReducerState(EMPTY_SETTINGS_SCHEMA);
    }), reducerState = _a[0], dispatch = _a[1];
    var _b = react_1.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(false), isSaving = _c[0], setIsSaving = _c[1];
    var _d = react_1.useState(false), hasInitialized = _d[0], setHasInitialized = _d[1];
    var _e = react_1.useState(''), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = react_1.useState(''), successMessage = _f[0], setSuccessMessage = _f[1];
    // Selection state lives in the reducer so add/delete/discard actions can
    // update it atomically — no follow-up `useEffect` bookkeeping required.
    // --- Initial load -------------------------------------------------
    react_1.useEffect(function () {
        var mounted = true;
        var loadConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, normalized, error_1, err, rawStatus, errorStatus;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setIsLoading(true);
                        setErrorMessage('');
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, service.getConfiguration()];
                    case 2:
                        response = _d.sent();
                        if (!isWsAiHubSettingsSchemaShape(response)) {
                            throw new Error('Invalid response from settings API');
                        }
                        if (!mounted) {
                            return [2 /*return*/];
                        }
                        normalized = ai_hub_settings_utils_1.sanitizeAiHubSettingsSchema(stripServerClientIds(response));
                        dispatch({ type: 'INIT_FROM_SAVED', saved: normalized });
                        setHasInitialized(true);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        if (process.env.NODE_ENV !== 'production') {
                            // Only log the message, never the raw error: axios-style errors
                            // carry `error.config.headers` (Authorization bearer tokens) and
                            // related request metadata that must not reach console sinks.
                            // eslint-disable-next-line no-console
                            console.error('Error loading AI Hub settings:', (_a = error_1) === null || _a === void 0 ? void 0 : _a.message);
                        }
                        if (!mounted) {
                            return [2 /*return*/];
                        }
                        err = error_1;
                        rawStatus = (_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : err === null || err === void 0 ? void 0 : err.status;
                        errorStatus = typeof rawStatus === 'number' ? rawStatus : NaN;
                        if (errorStatus === 404) {
                            dispatch({
                                type: 'INIT_FROM_SAVED',
                                saved: EMPTY_SETTINGS_SCHEMA,
                            });
                            setHasInitialized(true);
                        }
                        else {
                            setErrorMessage('Could not load data sources. Please reload and try again.');
                            setHasInitialized(false);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (mounted) {
                            setIsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        loadConfiguration();
        return function () {
            mounted = false;
        };
    }, []);
    // --- Derived state -----------------------------------------------
    var savedConfig = hasInitialized ? reducerState.saved : null;
    var draftConfig = hasInitialized ? reducerState.draft : null;
    var changeFlags = react_1.useMemo(function () { return ai_hub_settings_change_flags_1.computeSettingsChangeFlags(reducerState.draft, reducerState.saved); }, [reducerState.draft, reducerState.saved]);
    var hasChanges = changeFlags.hasAnyChanges;
    // --- Action wrappers ---------------------------------------------
    var dispatchAndClearSuccess = react_1.useCallback(function (action) {
        dispatch(action);
        setSuccessMessage('');
    }, []);
    var setSelectedSystemId = react_1.useCallback(function (id) {
        dispatchAndClearSuccess({ type: 'SET_SELECTED_SYSTEM', clientId: id });
    }, [dispatchAndClearSuccess]);
    var setSelectedWorkflowId = react_1.useCallback(function (id) {
        dispatchAndClearSuccess({
            type: 'SET_SELECTED_WORKFLOW',
            clientId: id,
        });
    }, [dispatchAndClearSuccess]);
    var setSelectedFieldId = react_1.useCallback(function (id) {
        dispatchAndClearSuccess({ type: 'SET_SELECTED_FIELD', clientId: id });
    }, [dispatchAndClearSuccess]);
    // ADD_SYSTEM/ADD_FIELD/DELETE_*/DISCARD_*_EDIT atomically update
    // selection inside the reducer; no follow-up effect is required.
    var addSystem = react_1.useCallback(function () {
        dispatchAndClearSuccess({ type: 'ADD_SYSTEM' });
    }, [dispatchAndClearSuccess]);
    var updateSystemField = react_1.useCallback(function (clientId, key, value) {
        dispatchAndClearSuccess({
            type: 'UPDATE_SYSTEM_FIELD',
            clientId: clientId,
            key: key,
            value: value || '',
        });
    }, [dispatchAndClearSuccess]);
    var updateSystemConfig = react_1.useCallback(function (clientId, nextConfig) {
        dispatchAndClearSuccess({
            type: 'UPDATE_SYSTEM_CONFIG',
            clientId: clientId,
            config: nextConfig,
        });
    }, [dispatchAndClearSuccess]);
    var deleteSystem = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DELETE_SYSTEM', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var discardSystemEdit = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DISCARD_SYSTEM_EDIT', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var addWorkflow = react_1.useCallback(function () {
        dispatchAndClearSuccess({ type: 'ADD_WORKFLOW' });
    }, [dispatchAndClearSuccess]);
    var updateWorkflowField = react_1.useCallback(function (clientId, key, value) {
        dispatchAndClearSuccess({
            type: 'UPDATE_WORKFLOW_FIELD',
            clientId: clientId,
            key: key,
            value: value || '',
        });
    }, [dispatchAndClearSuccess]);
    var updateWorkflowSystems = react_1.useCallback(function (clientId, role, values) {
        dispatchAndClearSuccess({
            type: 'UPDATE_WORKFLOW_SYSTEMS',
            clientId: clientId,
            role: role,
            values: values,
        });
    }, [dispatchAndClearSuccess]);
    var deleteWorkflow = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DELETE_WORKFLOW', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var discardWorkflowEdit = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DISCARD_WORKFLOW_EDIT', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var addField = react_1.useCallback(function () {
        dispatchAndClearSuccess({ type: 'ADD_FIELD' });
    }, [dispatchAndClearSuccess]);
    var updateFieldName = react_1.useCallback(function (clientId, name) {
        dispatchAndClearSuccess({ type: 'UPDATE_FIELD_NAME', clientId: clientId, name: name });
    }, [dispatchAndClearSuccess]);
    var toggleFieldIgnore = react_1.useCallback(function (clientId, ignore) {
        dispatchAndClearSuccess({
            type: 'TOGGLE_FIELD_IGNORE',
            clientId: clientId,
            ignore: ignore,
        });
    }, [dispatchAndClearSuccess]);
    var deleteField = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DELETE_FIELD', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var discardFieldEdit = react_1.useCallback(function (clientId) {
        dispatchAndClearSuccess({ type: 'DISCARD_FIELD_EDIT', clientId: clientId });
    }, [dispatchAndClearSuccess]);
    var addMapping = react_1.useCallback(function (fieldId) {
        dispatchAndClearSuccess({ type: 'ADD_MAPPING', fieldId: fieldId });
    }, [dispatchAndClearSuccess]);
    var removeMapping = react_1.useCallback(function (fieldId, mappingId) {
        dispatchAndClearSuccess({ type: 'REMOVE_MAPPING', fieldId: fieldId, mappingId: mappingId });
    }, [dispatchAndClearSuccess]);
    var updateMapping = react_1.useCallback(function (fieldId, mappingId, action) {
        dispatchAndClearSuccess({
            type: 'MAPPING_ACTION',
            fieldId: fieldId,
            mappingId: mappingId,
            action: action,
        });
    }, [dispatchAndClearSuccess]);
    // --- Save / discard ----------------------------------------------
    var saveChanges = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var normalizedDraft, response, rawMessage, safeMessage, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!hasInitialized) {
                        return [2 /*return*/];
                    }
                    setIsSaving(true);
                    setErrorMessage('');
                    setSuccessMessage('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    normalizedDraft = ai_hub_settings_utils_1.sanitizeAiHubSettingsSchema(reducerState.draft);
                    return [4 /*yield*/, service.saveConfiguration(normalizedDraft)];
                case 2:
                    response = _b.sent();
                    if (!response || typeof response !== 'object') {
                        throw new Error('Invalid response from settings save API');
                    }
                    // Re-seed saved/draft from a fresh clone so client ids remain stable
                    // across the round-trip (sanitize strips them, MARK_SAVED reassigns).
                    dispatch({
                        type: 'MARK_SAVED',
                        saved: ai_hub_settings_utils_1.cloneAiHubSettingsSchema(normalizedDraft),
                    });
                    rawMessage = typeof response.message === 'string' ? response.message : '';
                    safeMessage = rawMessage.slice(0, 200);
                    setSuccessMessage(safeMessage || 'Settings saved successfully');
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error saving AI Hub settings:', (_a = error_2) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    setErrorMessage('Unable to save data sources.');
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [hasInitialized, reducerState.draft, service]);
    var discardChanges = react_1.useCallback(function () {
        dispatch({ type: 'DISCARD_ALL' });
        setSuccessMessage('');
        setErrorMessage('');
    }, []);
    // Selection auto-update on add/delete/discard happens atomically inside
    // the reducer; the previous `useEffect`-based auto-select bookkeeping
    // has been removed.
    return {
        savedConfig: savedConfig,
        draftConfig: draftConfig,
        isLoading: isLoading,
        isSaving: isSaving,
        errorMessage: errorMessage,
        successMessage: successMessage,
        hasChanges: hasChanges,
        changeFlags: changeFlags,
        selectedSystemId: reducerState.selectedSystemId,
        setSelectedSystemId: setSelectedSystemId,
        selectedWorkflowId: reducerState.selectedWorkflowId,
        setSelectedWorkflowId: setSelectedWorkflowId,
        selectedFieldId: reducerState.selectedFieldId,
        setSelectedFieldId: setSelectedFieldId,
        newSystemIds: reducerState.newSystemIds,
        newWorkflowIds: reducerState.newWorkflowIds,
        newFieldIds: reducerState.newFieldIds,
        addSystem: addSystem,
        updateSystemField: updateSystemField,
        updateSystemConfig: updateSystemConfig,
        deleteSystem: deleteSystem,
        discardSystemEdit: discardSystemEdit,
        addWorkflow: addWorkflow,
        updateWorkflowField: updateWorkflowField,
        updateWorkflowSystems: updateWorkflowSystems,
        deleteWorkflow: deleteWorkflow,
        discardWorkflowEdit: discardWorkflowEdit,
        addField: addField,
        updateFieldName: updateFieldName,
        toggleFieldIgnore: toggleFieldIgnore,
        deleteField: deleteField,
        discardFieldEdit: discardFieldEdit,
        addMapping: addMapping,
        removeMapping: removeMapping,
        updateMapping: updateMapping,
        saveChanges: saveChanges,
        discardChanges: discardChanges,
    };
};
